import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";
import * as React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { deleteCustomerSraDepartment } from "../actions";
import { basePathSelector } from "../selectors";
import { customerSelector } from "../../customer/selectors";
import { Customer } from "../../customer";
import { ApplicationState } from "../../../applicationState";

interface MergedProps {
    delete: () => void;
}

class DeleteButton extends React.Component<MergedProps> {

    public render() {
        return (
            <ConfirmedButton
                icon="delete"
                content="Delete"
                floated="left"
                className="warning"
                onClick={this.onDelete}
                promptText="Are you sure you want to delete this SRA Department? Type 'DELETE' and click confirm to delete."
                typeToConfirmText="DELETE"
                headingText="Delete SRA Department"
            />);
    }

    private onDelete = () => this.props.delete();
}

interface StateProps {
    customerSraDepartmentId: string;
    basePath: string;
    customer: Customer;
}

interface DispatchProps {
    dispatchDelete: (customerId: string, customerSraDepartmentId: string, basePath: string) => void;
}

function mapStateToProps(state: ApplicationState): StateProps {
    return {
        customerSraDepartmentId: state.router.params.customerSraDepartmentId,
        basePath: basePathSelector(state),
        customer: customerSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<ApplicationState, undefined, any>): DispatchProps {
    return {
        dispatchDelete: (customerId, customerSraDepartmentId, basePath) =>
            dispatch<any>(deleteCustomerSraDepartment(customerId, customerSraDepartmentId, basePath))
    };
}

function mergeProps(propsFromState: StateProps, propsFromDispatch: DispatchProps): MergedProps {
    return {
        delete: () =>
            propsFromDispatch.dispatchDelete(propsFromState.customer.id, propsFromState.customerSraDepartmentId, propsFromState.basePath)
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeleteButton);
